import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { getFormatted } from "helpers/formatting";
import { downloadArealDocument } from "helpers/download";
import { PictureAsPdf } from "components/Icons";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true,
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: (rowData) => (
      <PictureAsPdf
        id={`download-delivery-notes-${rowData.DocumentId}.pdf`}
        onClick={(e) => {
          e.stopPropagation();
          downloadArealDocument(rowData);
        }}
      />
    ),
    visible: true,
    notRowClick: true,
  },
  {
    title: "COUNTERPARTY_NAME",
    fixedWidth: 430,
    key: "LicenceContractLine.LicenceContract.Licensor.Name",
    visible: true,
  },
  {
    title: "COUNTERPARTY_NUMBER",
    key: "LicenceContractLine.LicenceContract.Licensor.Number",
    visible: true,
  },
  {
    title: "HARVEST_YEAR",
    key: "AreaStatement.HarvestYear",
    visible: true,
  },
  {
    title: "DELIVERIES_GENUS",
    key: "LicenceContractLine.LicenceContract.Specie",
    visible: true,
  },
  {
    title: "CULTIVAR",
    key: "LicenceContractLine.LicenceContract.Cultivar",
    visible: true,
  },
];
